/**
 * Games Info Category Model
 */

define(function(require, exports, module) {
    'use strict';

    var _ = require('underscore');
    var BaseModel = require('common/base.model');
    var jackpotModel = require('replacers/jackpot/jackpot.model.instance');
    var util = require('utils');

    module.exports = BaseModel.extend({

        idAttribute: 'name',

        defaults: {
            isLoading: false,
            dynamic: false,
            isShowGamesWhileLoading: true,
            customLayout: null
        },

        initialize: function(attributes, options) {
            this.set('allGames', options.allGames);
        },

        subscribe: function() {
            this.listenTo(this, 'change:games', this._handleGamesChange);
        },

        //region Games Sorting

        /**
         * Sorts Games in Category by given sortField
         */
        sortGames: function(sortField) {
            if (sortField === 'default') {
                this.get('games').sort(function(a, b) {
                    return this.get('gamesInitialOrder').indexOf(a) - this.get('gamesInitialOrder').indexOf(b);
                }.bind(this));

                return;
            }

            var gameNames = this.get('games');
            var fieldPredicate = this._getFieldSortingPredicate(sortField);
            var indexPredicate = this._getIndexesSortingPredicate(gameNames);
            var finalPredicate = function(a, b) {
                return fieldPredicate(a, b) || indexPredicate(a, b);
            };
            // map games on game names and sort
            var games = _.compact(this._getGamesByNames(gameNames)).sort(finalPredicate);

            var findIndex = function(item) {
                return _.findIndex(games, function(game) {
                    if (game.get('gameCode') === item) {
                        return true;
                    }
                });
            };

            // sort game names by their indexes
            // NB if we overwrite category.games we'll lose previous sorting state, what contradicts with requirements
            gameNames.sort(function(a, b) {
                return findIndex(a) - findIndex(b);
            });
        },

        _getProps: function(name, a, b) {
            return {
                a: a.get(name),
                b: b.get(name)
            };
        },

        _getGamesByNames: function(names) {
            return names.map(function(name) {
                return this.get('allGames').find(function(game) {
                    return game.get('gameCode') === name;
                });
            }, this);
        },

        _getFieldSortingPredicate: function(field) {
            var predicate, props;

            // property names should be hardcoded
            switch (field) {
                case 'new':
                    predicate = function(a, b) {
                        props = this._getProps('new', a, b);
                        return util.predicate.boolPredicate(props.a, props.b);
                    };
                    break;
                case 'popular':
                    predicate = function(a, b) {
                        props = this._getProps('popular', a, b);
                        return util.predicate.boolPredicate(props.a, props.b);
                    };
                    break;
                case 'jackpotCode':
                    var jackpots = jackpotModel.get('jackpots');

                    if (!jackpots) {
                        predicate = function() {
                            return 0;
                        };
                        break;
                    }

                    predicate = function(a, b) {
                        props = {
                            a: jackpots[a.get('jackpotCode')] && jackpots[a.get('jackpotCode')][0].amount,
                            b: jackpots[b.get('jackpotCode')] && jackpots[b.get('jackpotCode')][0].amount
                        };
                        return util.predicate.numberPredicate(props.a, props.b);
                    };
                    break;
                case 'isInFavorites':
                    predicate = function(a, b) {
                        props = this._getProps('isInFavorites', a, b);
                        return util.predicate.boolPredicate(props.a, props.b);
                    };
                    break;
                case 'name':
                    predicate = function(a, b) {
                        props = this._getProps('name', a, b);
                        return util.predicate.stringPredicate(props.a, props.b);
                    };
                    break;
            }

            return predicate.bind(this);
        },

        _getIndexesSortingPredicate: function(gameNames) {
            var initialIndexes = gameNames.reduce(function(pVal, item, idx) {
                pVal[item] = idx;
                return pVal;
            }, {});

            return function(a, b) {
                var props = this._getProps('gameCode', a, b);

                if (initialIndexes[props.a] === initialIndexes[props.b]) {
                    return 0;
                }

                return initialIndexes[props.a] - initialIndexes[props.b];
            }.bind(this);
        },

        //endregion

        _handleGamesChange: function() {
            this.set('gamesInitialOrder', _.clone(this.get('games')));
        }
    });
});
